import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    statusCreate: 'idle', // idle loading success fail  
    error: null,
    errorCreate: null
}

const PLATFORM = '../../WsWebServicePlatform/'

export const fetchParticipants = createAsyncThunk('participants/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response= await axios.get(PLATFORM + "Admin/Search/Participants/Get/" + incomingVariable.authToken + "/"+incomingVariable.page+"/"+"1/")
        const data = await response.data.Success ? response.data : []
        
        return data
    } catch (err) {
        
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const createParticipants = createAsyncThunk('participants/create', async (incomingVariable, thunkAPI) => {
    
    const bodies = {ParamData:{...incomingVariable}}
    try {

        // "AuthToken": "3A08EFF5-2E7C-4D38-8526-65E46A3BEBC2",
        // "GroupGuid": "63D1EDC-0E67-4337-A8B1-D8207B9C5067",
        // "LanguageID": "1",
        // "LastName": "Smith",
        // "FirstName": "Cletus",
        // "MiddleName": "Jethro",
        // "BioDOB": "1955-02-14",
        // "BioGender": "1",
        // "BioRace": "687",
        // "BioRace2": "~~",
        // "BioRace3": "~~",
        // "SpokenLanguageID": "~~",
        // "Email": "noreply@wellsource.com",
        // "StatusID": "1",
        // "EducationLevelGuid": "27A9924F-501B-4EAB-A099-E515DB0F0FDE",
        // "Medicaid": "0",
        // "Username": "Jethro",
        // "Password": "qwe123QWE!!!",
        // "PasswordChangeRequired": "0"        
        const response= await axios.post(PLATFORM + "Group/ParticipantAndLogin/Create",bodies)
        const data = await response.data
        
        return data
    } catch (err) {
        
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const adminparticipantSlice = createSlice({
    name: 'adminparticipants',
    initialState,
    reducers: {
        adminparticipantAdd(state, action) {
            const adminparticipantData = action.payload
            state.entities[adminparticipantData.ParticipantGuid] = adminparticipantData
        },
        adminparticipantModify(state, action) {
            const adminparticipantData = action.payload
            state.entities[adminparticipantData.ParticipantGuid] = adminparticipantData
        },

        adminparticipantDelete(state, action) {
            const adminparticipantData = action.payload
            delete state.entities[adminparticipantData.ParticipantGuid]
        },
        adminparticipantHydrate(state, action) {
            const adminparticipantData = action.payload
            state.entities = adminparticipantData
            state.status = 'success'
        },
        adminparticipantClearCreate(state, action){
            state.statusCreate = 'idle'
            state.errorCreate = null
        },
        adminparticipantClear(state, action){
            state.statusCreate = 'idle'
            state.errorCreate = null
            state.status = 'idle'
            state.error = null
            state.entities = {}

        }
    },
        extraReducers(builder) {
      builder
      .addCase(fetchParticipants.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchParticipants.fulfilled, (state, action) => {
        state.status = 'success'
        const loadedData = action.payload.Info
        
        const data={}
        for (var i = 0; i< loadedData.length; i++){
          const partObject = loadedData[i]
          data[partObject.ParticipantGuid] = partObject
        }
        state.entities = data
      })
      .addCase(fetchParticipants.rejected, (state, action) => {
        state.error = action.error.message
        
      })
      ////
      ////
      ////
      .addCase(createParticipants.pending, (state, action) => {
        state.statusCreate = 'loading'
      })
      .addCase(createParticipants.fulfilled, (state, action) => {
        const Success=action.payload.Success
        if(Success===true){
            const loadedData = action.payload.Info[0]
            state.entities[loadedData.ParticipantGuid] = loadedData
            state.statusCreate = 'success'

        }else {
            state.statusCreate = "failed"
            state.errorCreate = action.payload.Status[0]
        }
      
      })
      .addCase(createParticipants.rejected, (state, action) => {
        state.statusCreate = "failed"
        state.errorCreate = action.error.message
        
      })
    }
})

export const { adminparticipantAdd, adminparticipantModify, adminparticipantDelete, adminparticipantHydrate,adminparticipantClearCreate,adminparticipantClear } = adminparticipantSlice.actions

export default adminparticipantSlice.reducer

const selectAdminParticipantEntities = (state) => state.adminparticipants.entities

export const selectAdminParticipants = createSelector(selectAdminParticipantEntities, (entities) =>
    Object.values(entities)
)

export const selectAdminParticipantById = (state, AdminParticipantId) => {
    return selectAdminParticipantEntities(state)[AdminParticipantId]
}

